import { RawAxiosRequestHeaders } from 'axios';
import { StringifiableRecord } from 'query-string';

import { checkSessionAction } from 'stores';
import { addQueryParamsToURL } from 'utils';

import { IRequestCallbackParams } from 'types';

type THandleRequestParams<P> = {
  run: (params: Pick<THandleRequestParams<P>, 'baseURL' | 'headers'> & { url: string; payload?: P }) => void;
  url?: string;
  headers: RawAxiosRequestHeaders;
  baseURL?: string;
  queryParams?: StringifiableRecord;
};

export const handleRequest = <P>({
  run,
  url,
  baseURL,
  headers,
  queryParams,
}: THandleRequestParams<P>) => (
  params?: IRequestCallbackParams<P>,
) => {
  const { payload, callbackQueryParams, callbackURL } = params || {};

  checkSessionAction();

  const urlWithParams = addQueryParamsToURL(String(callbackURL || url), callbackQueryParams || queryParams);

  run({ url: urlWithParams, payload, baseURL, headers });
};
